export const Minimize = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M28 13.0116L19 13.0116L19 4.0116" stroke="currentColor" stroke-width="2"/>
<path d="M29.293 2.72253L19 13.0116" stroke="currentColor" stroke-width="2"/>
<path d="M4 19H13L13 28" stroke="currentColor" stroke-width="2"/>
<path d="M2.70703 29.2891L13 19" stroke="currentColor" stroke-width="2"/>
</svg>`;
